import { getNowTimeHmss } from './time.js'

let LOGLEVEL = 10;

function setDebug() {
    LOGLEVEL = 0;
}

function d(arg1, arg2 = null) {
    if (LOGLEVEL > 0) {
        return;
    }

    if (arg2 != null) {
        console.log(getNowTimeHmss() + " " + arg1, arg2);
    } else {
        console.log(getNowTimeHmss(), arg1);
    }
}

function i(arg1, arg2 = null) {
    if (LOGLEVEL > 10) {
        return;
    }

    if (arg2 != null) {
        console.log(getNowTimeHmss() + " " + arg1, arg2);
    } else {
        console.log(getNowTimeHmss(), arg1);
    }
}

function e(arg1, arg2 = null) {
    if (arg2 != null) {
        console.error(getNowTimeHmss() + " " + arg1, arg2);
    } else {
        console.error(getNowTimeHmss(), arg1);
    }
}

export { d, i, e, setDebug }
